import React from 'react'

import StartFooterCTA from './StartFooterCTA.js';


export default class extends React.Component {

  render() {
    document.title = this.props.i18n_texts["milestones_title"][this.props.app_language]+" · Citrus by Polymedia";
    let alt_nl = document.createElement('link');alt_nl.rel = 'alternate';alt_nl.hreflang = 'x-default';alt_nl.href = 'https://citrus.polymedia.nl/mijlpalen';
    document.getElementsByTagName('title')[0].after(alt_nl);
    let alt_en = document.createElement('link');alt_en.rel = 'alternate';alt_en.hreflang = 'en';alt_en.href = 'https://citrus.polymedia.nl/en/milestones';
    document.getElementsByTagName('title')[0].after(alt_en);
    return (
      <div>

        <div className="full greyish">
          <div className="wrap wrap-thin">
            <small style={{opacity:".5", display:"block", marginTop:"3em", fontSize:"75%", textAlign:"right"}}>{this.props.i18n_texts["gen_lastmodified"][this.props.app_language]} 24-4-2024.</small>
            <div className="timeline milestones">

              <div className="tl-item">
                <div className="col-3 tl-stamp">
                  <p>10-4-2024</p>
                </div>
                <div className="col-9 tl-content">
                  <h1>{this.props.i18n_texts["milestones_1_title"][this.props.app_language]}</h1>
                </div>
              </div>

              <div className="tl-item">
                <div className="col-3 tl-stamp">
                  <p>16-4-2024</p>
                </div>
                <div className="col-9 tl-content">
                  <h1>{this.props.i18n_texts["milestones_2_title"][this.props.app_language]}</h1>
                </div>
              </div>

              <div className="tl-item">
                <div className="col-3 tl-stamp">
                  <p>25-4-2024</p>
                </div>
                <div className="col-9 tl-content">
                  <h1>{this.props.i18n_texts["milestones_3_title"][this.props.app_language]}</h1>
                  <p>{this.props.i18n_texts["milestones_3_text"][this.props.app_language]}</p>
                </div>
              </div>

            </div>
          </div>
        </div>

        <StartFooterCTA lang={this.props.app_language} openModal={this.props.openModal} />

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/StartPages/Milestones.js